/* eslint-disable max-params */
import API from "./API";

export default class ProductDescriptorViewsAPI {
  static createProductDescriptorView (productDescriptorId, kind) {
    return $.ajax({
      "data": {
        "product_descriptor_view": {
          kind,
          "product_descriptor_id": productDescriptorId
        }
      },
      "headers": API.authHeaders(),
      "method": "POST",
      "url": "/api/v1/product_descriptor_views/create"
    });
  }
}
